import { MonitoringTitleStyleModel } from '../../Shared/models/monitoring-title-style.model';
import { BriefingHeadingLevelEnum } from '../enums/briefing-heading-level.enum';
import { BriefingTextDisplayElementModel } from './briefing-text-display-element.model';

export class BriefingTitleDisplayElementModel extends BriefingTextDisplayElementModel {

    headingLevel: BriefingHeadingLevelEnum = BriefingHeadingLevelEnum.HEADING_1;

    constructor(
        content?: string,
        styles?: any,
        titleSettings?: string,
        automaticallyGenerated?: boolean
    ) {
        super(content, styles);

        this.styles = new MonitoringTitleStyleModel(styles);
        if (titleSettings){
            const parsedTitleSettings = JSON.parse(titleSettings);
            if (parsedTitleSettings.headingLevel) {
                this.headingLevel = parsedTitleSettings.headingLevel;
            }
        }

        this.automaticallyGenerated = automaticallyGenerated;
    }

    clone(): BriefingTitleDisplayElementModel {
        let clone = new BriefingTitleDisplayElementModel(
            this.text,
            this.styles && this.styles.clone ? this.styles.clone() : JSON.parse(JSON.stringify(this.styles))
        );

        clone = super.clone(clone) as BriefingTitleDisplayElementModel;
        clone.headingLevel = this.headingLevel;
        clone.automaticallyGenerated = this.automaticallyGenerated;
        clone.canAutomaticallyGenerated = this.canAutomaticallyGenerated;
        clone.displayType = this.displayType;

        return clone;
    }

    isEqual(other: BriefingTitleDisplayElementModel): boolean {
        if (!super.isEqual(other)) {
            return false;
        }

        if (this.headingLevel !== other.headingLevel) {
            return false;
        }

        if (this.automaticallyGenerated !== other.automaticallyGenerated) {
            return false;
        }

        return true;
    }
}
